import React, {Component} from 'react'
import {Paper, withStyles} from '@material-ui/core'
import style from './style'

class MainPaper extends Component {

    render() {

        const { 
            contentSectionProps, 
            paperProps, 
            children,
            classes,
            after,
            footer,
            isOffline
        } = this.props

        const contentSectionClass = isOffline ? classes.offlineContentSection : classes.contentSection

        return (
            <div className={contentSectionClass} {...contentSectionProps}>
                <div id="printScreen">
                    <Paper className={classes.mainPaper} square elevation={0} {...paperProps}>
                        <div className={classes.paperContent}>
                            {children}
                        </div>
                        { footer && 
                            <Paper className={classes.paperFooter} square elevation={0}>
                                {footer}
                            </Paper>
                        }
                    </Paper>
                </div>
                { after && 
                    <div className={classes.after}>
                        {after}
                    </div>
                }
            </div>
        )
    }

}

export default withStyles(style)(MainPaper)